import Component from '../core/Component'
import throttle from 'lodash/throttle'

export default class Decorations extends Component {
    constructor(element) {
        super(element)

        this.scrollHandler = throttle(::this.scroll);
        this.resizeHandler = throttle(::this.resize);
    }

    prepare() {


        this.ref.decorations.forEach(item => {
            item.multiplier = JSON.parse(item.dataset.multiplier);
        });

        window.addEventListener('scroll', this.scrollHandler);
        window.addEventListener('resize', this.resizeHandler);
        this.resize();
        this.scroll();
    }

    destroy() {
        window.removeEventListener('scroll', this.scrollHandler)
        window.removeEventListener('resize', this.resizeHandler);
    }

    resize(event) {
        var body = document.body, html = document.documentElement;
        this.docHeight = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
        this.height = this.docHeight - this.element.offsetHeight;
    }

    scroll () {
        let percent = Math.round(window.pageYOffset/this.height*1000)/100;
        // move decorations
        this.ref.decorations.forEach(item => {
            let x = percent*item.multiplier.x;
            let y = percent*item.multiplier.y;
            let r = percent*item.multiplier.r;
            item.style.transform = `translate3d(${x}px, ${y}px, 0) rotate(${r}deg)`;
        });
    }
}


// WEBPACK FOOTER //
// ./components/Decorations.js